export default __webpack_public_path__ + "static/media/Car.a3ade830.svg";